export function openStoreOrAppUrl(url: string, sameWindow?: boolean): void {
  if (typeof window === 'undefined') return;
  const link = document.createElement('a');
  link.href = url;
  link.rel = 'noopener noreferrer';
  link.target = sameWindow ? '_self' : '_blank';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
